import { TimeService } from '../../../service/TimeService';
import { KalmanFilterNode } from './KalmanFilterNode';
/**
 * Relative position filter to filter the relative positions of an object depending on criteria
 */
export class RelativePositionFilter extends KalmanFilterNode {
  constructor(relativePositionType, options) {
    super(undefined, undefined, options);
    this._relativePositionType = relativePositionType;
    this.options.maxTimeDifference = this.options.maxTimeDifference || Infinity;
  }
  processObject(object) {
    return new Promise((resolve, reject) => {
      const relativePositions = object.relativePositions
      // For each relative position matching the type
      .filter(x => x instanceof this._relativePositionType);
      Promise.all(relativePositions
      // Filter the reference value with the built-in filter (key being object uid)
      .map(relPos => {
        return this.filterValue(object, relPos.referenceValue, relPos.referenceObjectUID);
      })).then(results => {
        results.forEach((result, idx) => {
          const value = result;
          const relativePosition = relativePositions[idx];
          if (typeof value === 'number' && (this.options.maxValue ? value <= this.options.maxValue : true) && (this.options.minValue ? value >= this.options.minValue : true) && TimeService.now() - this.options.maxTimeDifference <= relativePosition.timestamp) {
            relativePosition.referenceValue = value;
          } else {
            object.removeRelativePositions(relativePosition.referenceObjectUID);
          }
        });
        resolve(object);
      }).catch(reject);
    });
  }
}